/**
 * Generated by `tools/blender/merge-landmark-manifests.mjs`.
 *
 * The checked-in values let procedural tiles suppress source-footprint massing
 * before the matching authored GLBs are attached. Do not edit this file by
 * hand; update a source landmark manifest and rebuild the Blender assets.
 */
export const VILNIUS_LANDMARK_REPLACED_BUILDING_ID_VALUES = Object.freeze([
  "grpk:00ac4fb3-627c-4095-ab8d-f1685bfa8850",
  "grpk:02084566-3a6e-4748-8b6a-fdee3fb46ce8",
  "grpk:0435b1a9-eab6-4918-bdf3-695eb94235e1",
  "grpk:04c9812a-9a89-4a0f-9db0-c5a8222536e0",
  "grpk:08b48536-19f7-4c48-a174-15ef0f381712",
  "grpk:0BAEA6FB-6152-476D-B9C0-5C81AAE9EE98",
  "grpk:0C53B0FD-9988-4F51-94FE-6F51F5AED591",
  "grpk:0dbc23e5-a713-44bc-af8f-e1bb06c7ed98",
  "grpk:0E6881F1-1C7E-4A7E-A056-2F2323E4C38A",
  "grpk:0e6cb94a-e57b-4316-a321-55ef357d63a1",
  "grpk:1062149A-C73F-44F4-9B4A-E3D59F27CB97",
  "grpk:13414970-2238-4dff-85e0-5be26501d828",
  "grpk:14953026-ab3a-4b12-bea4-81d34b30a0a3",
  "grpk:16DFD85F-2F9C-43C3-B255-0781CA91AD2A",
  "grpk:1A3AE562-C0CB-4504-88B4-D7AF4CA1B12A",
  "grpk:1b4839cc-2ec3-4aef-bbf4-960a9ae317d4",
  "grpk:1E081770-CCB8-46C5-8D8C-A73243F2173D",
  "grpk:1F5610BD-BF0B-4CBE-B013-C1C2CC63AC37",
  "grpk:20758473-25E7-443A-88CC-FF5026C4E18E",
  "grpk:24bd081a-0ad1-458b-a505-0909860a96f1",
  "grpk:27D50581-FC8A-44EA-AA60-B508B2E6DBBB",
  "grpk:28A5C0FE-4CB3-4B57-8351-DCFBB94D2A55",
  "grpk:29EC288B-4D3F-41D4-BFD9-190EF8AD8981",
  "grpk:2E260EC5-F7FD-4756-9C7D-855C8A2FF8AB",
  "grpk:30A429EE-6177-4F0B-85F1-83798533C415",
  "grpk:311A82D0-ACEA-4961-BB12-00A328E06480",
  "grpk:3353ADC6-2CAE-4F49-AB02-833E1C3824A6",
  "grpk:35738098-CADC-4A0C-B503-18A37A44248F",
  "grpk:35ab31bc-b262-480a-bb78-42995c878422",
  "grpk:35C995EE-E284-4D3B-9551-9D71291EE731",
  "grpk:35F941A7-4628-4213-A5C9-9CF9B1CC33F2",
  "grpk:37A9D2C2-EA97-43C7-BF65-49E15F2A1C88",
  "grpk:39044BF7-5454-454C-ADB1-FA0098EF7CFC",
  "grpk:3A761A11-25A9-4830-A027-65D97481332B",
  "grpk:3DF29079-F081-410A-AFC9-A4A72CE2F275",
  "grpk:3F29EEC8-FDF3-43C4-AE86-5F3163BD4FDF",
  "grpk:3f5a7379-04fa-4d84-9dab-a3a998a252d5",
  "grpk:408D21B5-2B99-49CC-AFA2-89E1F77B8FB8",
  "grpk:419EC267-A64E-4DDF-ABFB-5AFDE0A275D4",
  "grpk:41FDF7DF-CF50-40D2-A469-2B674312C80F",
  "grpk:426C8738-2B97-44A4-8F2B-D12AC7C21D43",
  "grpk:43E7CE5C-7795-47E1-BF1E-0E0EEE26A491",
  "grpk:46C27F7B-2B90-4B45-9BD0-B8DB9547B327",
  "grpk:47C2D484-694F-4B97-84B7-1FC93DA09503",
  "grpk:48A7913A-C03D-4779-9039-9DDD03D4A3F4",
  "grpk:48DFCE7B-706F-430C-A7AA-8CF9328A82BD",
  "grpk:4A410B60-79D6-4354-AECC-C9A9D229F6A9",
  "grpk:4ef6f18c-9575-482d-9288-b11f45076624",
  "grpk:4FAEBF05-2EA5-4431-BC53-22B26463179A",
  "grpk:4FC66F69-0FFA-4E31-886F-35436CC8528B",
  "grpk:575DBB13-3E4B-4A6A-8FD3-B79B1727FE70",
  "grpk:58E128CE-42D4-424D-8914-EE21D2D652DE",
  "grpk:58f353a1-513e-45bd-9105-1158dca6478b",
  "grpk:59b16979-e123-4d87-8af6-44d1e5a4fc0b",
  "grpk:5d56e00e-825a-4a11-9468-86918f5620cf",
  "grpk:5D71AA85-CD3F-438F-BC87-55AFC476CD4F",
  "grpk:5D8CCBC0-8D15-401E-BB68-031B040A8114",
  "grpk:5DAF7DC4-6FF9-4EBC-9FFC-EECC51CDAF5C",
  "grpk:5F630807-1418-432B-A2DD-06F2C399B242",
  "grpk:609D5194-B9F4-482D-876D-293740BF38D5",
  "grpk:61b36db7-c623-4ac1-9023-e2eef1740af0",
  "grpk:626b7fe6-8be4-48a7-9e97-37f30e622f66",
  "grpk:6450923a-d4da-4557-b89b-3f6d8abc21c8",
  "grpk:66FDA109-C093-4187-A88D-FC3BE731B109",
  "grpk:683C2887-D394-4CC7-A87C-A3AC64F86830",
  "grpk:68910335-2F84-4391-A071-2A9B06118AEF",
  "grpk:696513C3-3F36-41ED-85EF-6E813AEDC4BC",
  "grpk:6BCB4424-3280-413B-B9E7-CF0E7EAFEFD2",
  "grpk:6CA85295-5534-4E4D-841A-B038568EC8DF",
  "grpk:6E23B88E-EDD4-4A39-874E-ABDD2EA1E6C9",
  "grpk:6E4AD6BF-BCE1-4126-8034-670BF0A03F3A",
  "grpk:6F78F9CB-E1CA-46D7-A8B7-B2EDCD9C9B67",
  "grpk:760523E3-78A3-4E7B-96A1-99E6C36F531A",
  "grpk:763B3F98-E223-45B0-9D8B-C273B2589E48",
  "grpk:7645a3e6-7e52-4a0a-9615-db7efd8cd83d",
  "grpk:7661ff0a-44d4-463e-b532-3d6d28f44b9a",
  "grpk:7C91E821-E6EF-4C79-BAA2-0B9CE4CB5C9A",
  "grpk:7E7BFEA3-6C1C-4047-A155-12290F1A9E19",
  "grpk:7FB484FD-B190-44B8-9844-8EB7432B8432",
  "grpk:7FFA599F-307D-4D9F-B970-8BBAB36ECD00",
  "grpk:8148B54F-DE64-4AA9-89F9-8B054B0D3D7E",
  "grpk:829DBA27-52DB-4556-86F0-2B8882D22923",
  "grpk:87119456-4c1e-4d4e-8ddf-a95c2360e239",
  "grpk:8754F31C-6FB0-4CC3-9985-846B581E6F13",
  "grpk:87D535C2-472F-48AF-86A3-C924152B5EBA",
  "grpk:882b379a-60ee-4750-9df5-147bae3c5fa3",
  "grpk:883dad6e-3ffe-437d-a3b0-38fba187ffd9",
  "grpk:8BAFF3E5-7D41-4CDF-BA90-0319B8E69FDB",
  "grpk:8CE71B97-A35D-4C97-BFB4-9D96944DB87E",
  "grpk:8d1c996f-7bfc-442c-a9a6-5318db31bb43",
  "grpk:8d7a49ae-99e1-40da-ae7d-410a4b418caf",
  "grpk:8DB583A0-A1A5-4417-8465-BBB158933F45",
  "grpk:8e1e149c-7c31-407b-94d3-d29aae28773d",
  "grpk:8E20530A-46AB-4B92-8C43-31A46213F7D0",
  "grpk:9157213d-7e15-4376-9f50-1d0dd71ecaa6",
  "grpk:94AA929C-670F-48BE-8B3A-07E209105555",
  "grpk:953ef28c-6301-4b12-b1b2-2d680f32b58c",
  "grpk:958966CD-30F7-4690-923C-05CE379D2BEA",
  "grpk:95AA3F0A-F9ED-4320-9273-11F39626A1DE",
  "grpk:96e90cd4-3ea6-494c-9db6-5b43c29fdc79",
  "grpk:974a65a0-d55b-438b-8595-eb6076584ed1",
  "grpk:974B95F5-3E77-48B5-90C1-D97599787D5D",
  "grpk:991b8cd9-6602-4571-9dcf-79b57b24d337",
  "grpk:9CD32FFF-207B-4911-9B5C-F54EF8164DAB",
  "grpk:9d3e77bc-b9ac-4f36-840f-66e134cfe304",
  "grpk:9da4f458-91ef-4efb-97a2-c7f5b8fe48a6",
  "grpk:a000bc6c-f975-4bff-bc87-4f3f72e18b23",
  "grpk:A0489C16-CC7F-4B5B-9E0D-323587971198",
  "grpk:A0672DB1-77B3-4517-9273-00EF50E07D9B",
  "grpk:a2be8273-8c54-4841-afd5-8d51d9c61f6c",
  "grpk:A507EE10-BD81-4AF7-986F-B32AB935DE2C",
  "grpk:A9473120-8555-4311-BE10-05B66AA372EA",
  "grpk:abda6b2a-f2e6-4e54-bfd7-be586be8c57a",
  "grpk:AC6EE626-76F0-4864-B502-7A3C6BE6E5EE",
  "grpk:ACE57F2D-D398-4FA5-A7C9-2E77889155DB",
  "grpk:AD3FE82D-9561-4982-9044-0DC8855E63E9",
  "grpk:ADAC8507-5F60-4A10-9178-4D4634DDFF70",
  "grpk:b0a1459b-2bb8-4f3c-8064-2059ed1e682f",
  "grpk:b27732aa-5515-4409-b165-4f771e802dd7",
  "grpk:B36C6CBC-81F3-4A34-AFA9-C3885D644547",
  "grpk:B381BEF8-D4B9-4254-88B6-838101CA57F9",
  "grpk:b386af9b-e3e5-4496-9597-81e6fafe073a",
  "grpk:B3A44F27-7912-4354-BBC6-237090A5E131",
  "grpk:b3a9e089-ccea-49a6-8d09-5d6f88571e06",
  "grpk:B688D078-0886-4239-8481-2E99E75ED196",
  "grpk:B95FECA9-EB69-43A4-8414-5A7DF1C3276B",
  "grpk:BAB527E3-08A3-416E-AE07-ED1D82DBD68A",
  "grpk:BAC8B31C-D763-4AE0-9D0C-5C618D45B849",
  "grpk:BB0D4953-2583-4E9F-A27A-F25E9C772CB5",
  "grpk:bcc1e92e-f0da-4efa-a8c3-37607cf405bd",
  "grpk:be5a4af8-120c-4fb0-ae33-f04a2b3b1228",
  "grpk:BE7AB76D-981A-4F5A-B84D-0761AC7DC6BE",
  "grpk:BE8D0622-3B98-4968-B34D-A276C2468C9E",
  "grpk:BED5D665-D4A6-4050-A5DB-72632874FABB",
  "grpk:BEFC71ED-CAFC-407E-A801-24B9E37517B9",
  "grpk:bf588f3a-73ae-42d6-9885-73566e27ca83",
  "grpk:c0fa2986-f507-4946-98fc-537bf8cb1e30",
  "grpk:c26485e7-6b49-43db-9463-cfd90013594c",
  "grpk:C4460E2C-2111-499C-93BC-104BE190D7F4",
  "grpk:C46F7A72-43BB-4ABB-8AAF-6D351982E014",
  "grpk:C60A78CD-DD3B-456C-B36D-9DE750B82CBD",
  "grpk:C62DC73D-0341-4D77-81AA-D49271559982",
  "grpk:C6DC4870-6DF3-424E-9F7F-954E30E271FE",
  "grpk:CDA2E0F2-B465-400B-84C0-82B2AB9A0CAB",
  "grpk:CE5D10D5-2FD6-4ACD-B0C0-21550B7035A1",
  "grpk:D075B38A-E72E-47EC-8E88-5BD74D007E83",
  "grpk:d1866950-e94c-43c7-8d05-b9f6d9d5fe51",
  "grpk:d20a3715-3aa2-4c9d-9551-efe14db227da",
  "grpk:d2c53cdd-d01d-42ad-a76e-9442d2eed241",
  "grpk:d5610f06-8c80-4d51-aac0-54f621b5714c",
  "grpk:d70ee283-71dd-4898-833c-2de8992a6774",
  "grpk:D87FE376-6594-4089-AD3B-D75C78DD1C74",
  "grpk:D9C504E3-ACED-462B-A79E-A70F84E7933D",
  "grpk:DB9FF618-59D7-40A5-A60C-EAC9CC9D69C7",
  "grpk:dca5d090-0f08-457c-82fc-bc29a995327c",
  "grpk:DFA25394-3E0C-4A7C-A7FF-895C887CFC0A",
  "grpk:dfac816f-af4b-4185-abce-74c315b561bc",
  "grpk:E1F2C240-0CEA-4A32-9B1C-D7C68B5B55E8",
  "grpk:E224FF70-D00B-4CFE-AB06-E8CBD7CC1F4B",
  "grpk:E249D9A4-7167-418E-B6B8-F2884D9E729B",
  "grpk:E3B4E6BE-D7F3-48FD-BF84-43229E58302E",
  "grpk:E632A3CE-DA54-468A-83DA-4677DC4BE671",
  "grpk:e84c1b47-8144-4248-a592-ce0b3e5dc0ab",
  "grpk:f005c35c-3623-4c58-a8b6-fc16121c1af8",
  "grpk:F2B6B68B-FF0E-4643-A12B-DDD3562A1284",
  "grpk:F37142D2-DC0C-48E1-9904-16D254357E29",
  "grpk:F6095813-14D8-417A-9258-AF08A9764406",
] as const);
